import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { TeachersListPage } from '../teachers-list/teachers-list';
import { StudentsListPage } from '../students-list/students-list';
import { ClassroomsListPage } from '../classrooms-list/classrooms-list';
@Component({
    selector: 'page-home-principal',
    templateUrl: 'home-principal.html'
})

export class HomePrincipalPage {

    constructor(public navCtrl: NavController,
        public globals: Globals) {

    }


    openTechersList() {
        this.navCtrl.push(TeachersListPage);
    }

    openStudentsList() {
        this.navCtrl.push(StudentsListPage);
    }

    openClassrooms() {
        this.navCtrl.push(ClassroomsListPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/schools/home-principal/home-principal.ts